'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('web3-provider-engine/dist/es5/index');

var _index2 = _interopRequireDefault(_index);

var _fetch = require('web3-provider-engine/dist/es5/subproviders/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _filters = require('web3-provider-engine/dist/es5/subproviders/filters');

var _filters2 = _interopRequireDefault(_filters);

var _sanitizer = require('web3-provider-engine/dist/es5/subproviders/sanitizer');

var _sanitizer2 = _interopRequireDefault(_sanitizer);

var _fixture = require('web3-provider-engine/dist/es5/subproviders/fixture');

var _fixture2 = _interopRequireDefault(_fixture);

var _inflightCache = require('web3-provider-engine/dist/es5/subproviders/inflight-cache');

var _inflightCache2 = _interopRequireDefault(_inflightCache);

var _web3Subprovider = require('@ledgerhq/web3-subprovider');

var _web3Subprovider2 = _interopRequireDefault(_web3Subprovider);

var _hwTransportU2f = require('@ledgerhq/hw-transport-u2f');

var _hwTransportU2f2 = _interopRequireDefault(_hwTransportU2f);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (rpcUrl, networkId) {
  return function () {
    if (!networkId) {
      throw new Error('Network id not provided');
    }
    if (!networkId) {
      throw new Error('Network rpcUrl not provided');
    }
    var engine = new _index2.default();

    // static results
    engine.addProvider(new _fixture2.default({
      web3_clientVersion: 'ProviderEngine/v0.0.0/javascript',
      net_listening: true,
      eth_hashrate: '0x00',
      eth_mining: false,
      eth_subscribe: false
    }));
    engine.addProvider(new _sanitizer2.default());
    engine.addProvider(new _filters2.default());
    engine.addProvider(new _inflightCache2.default());

    var getTransport = function getTransport() {
      return new _hwTransportU2f2.default();
    };
    var ledgerProvider = (0, _web3Subprovider2.default)(getTransport, { networkId: networkId });
    engine.addProvider(ledgerProvider);
    engine.addProvider(new _fetch2.default({ rpcUrl: rpcUrl }));

    engine.start();
    return engine;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/walletProviders/ledgerProvider.js
// module id = 1241
// module chunks = 0